import { type RouteObject } from "react-router-dom";

import Community from "features/memberPortal/Community.screen";
import AuthenticatedRoute from "routing/AuthenticatedRoute";

import earRoutes from "./ear.routes";
import mailListRoutes from "./mailList.routes";
import nistRoutes from "./nist.routes";
import pcmRoutes from "./pcm.routes";
import productRoutes from "./product.routes";
import quickLinksRoute from "./quicklinks.routes";
import reportRoutes from "./reports.routes";
import trainingRoutes from "./training.routes";

const authenticatedRoutes: RouteObject[] = [
  {
    path: "community",
    element: <AuthenticatedRoute />,
    children: [
      {
        path: "*",
        element: <Community />,
        children: [
          // This probably isnt the best way to do this, but the Community screen doesn't render without it¯\_(ツ)_/¯
          { index: true, element: <></> },
          ...productRoutes,
          ...nistRoutes,
          ...earRoutes,
          ...reportRoutes,
          ...pcmRoutes,
          ...quickLinksRoute,
          ...trainingRoutes,
          ...mailListRoutes,
        ],
      },
    ],
  },

  // TODO: replace the * with the actual routes and pull out of community.screen
  { path: "*", element: <Community /> },
];

export default authenticatedRoutes;
